module.exports = __webpack_public_path__ + "img/hands.8e03e629.png";